import React, { useState, useEffect, useCallback } from "react";
import { clsx } from "clsx";

import CloseIcon from "@src/stories/components/CloseIcon/CloseIcon";

import shopify from "frontend/js/shopify";
import useMobileBreakpoint from "@src/hooks/useMobileBreakpoint";
import { mobileBreakpoint } from "@src/../entrypoints/theme";
import { addToCart } from "frontend/js/useShopifyCart";

let parentScrollPosition = 0;

export const ProductTileQuickAddOnHover = ({ product, isHovered }) => {
  const [addingVariantId, setAddingVariantId] = useState<number | null>(null);
  const [isMobileSizeOpen, setIsMobileSizeOpen] = useState(false);
  const [currentVariant, setCurrentVariant] = useState(null);
  const [isOpen, setIsOpen] = useState(false);
  const [unavailableForShipping, setUnavailableForShipping] = useState<string[]>([]);
  const isMobile = useMobileBreakpoint(mobileBreakpoint);

  const updateCurrentVariant = (variant) => {
    setCurrentVariant(variant);
  };

  if (isMobile) {
    const parentEl = document.querySelector('.lookbook-drawer');
    parentScrollPosition = parentEl ? parentEl.scrollTop : 0;

    const action = isOpen ? 'add' : 'remove';
    document.body.classList[action]("quick-add-open");
  }

  const handleQuickAdd = useCallback(async (event: React.MouseEvent, variant: any) => {
    event.preventDefault();
    event.stopPropagation();

    if (!variant?.available || !variant?.id) return;

    try {
      setAddingVariantId(Number(variant.id));
      await addToCart({ items: [{ id: Number(variant.id), quantity: 1 }] });
      setIsMobileSizeOpen(false);
    } catch {
      setAddingVariantId(null);
    } finally {
      setAddingVariantId(null);
    }
  }, []);
  
  useEffect(() => {
    async function fetchInvetoryDetails() {
      const variantIds = product?.variants?.map(variant => variant.id) || [];
      const response = await shopify.getInventoryDetails(variantIds);
      const nodes = response?.data?.nodes || []
      const _unavailableForShipping = nodes?.filter(node => {
        if (!node) return false;
        const inventoryLevels = node?.inventoryItem?.inventoryLevels?.nodes || [];
        const combinedStore = inventoryLevels.find(inventorylevel => inventorylevel.location?.name === "Combined Store");
        return !combinedStore || (combinedStore?.quantities?.[0]?.quantity ?? 0) <= 0;
      }).map(node => node?.id?.split("/").pop()) || [];

      setUnavailableForShipping(_unavailableForShipping);
    }

    fetchInvetoryDetails();
  }, [product])

  return (
    <>
      <div
        className={clsx(
          "absolute bottom-0 left-0 right-0 bg-white p-3 py-4 transition-opacity duration-200",
          isHovered ? "opacity-80" : "opacity-0 pointer-events-none",
        )}
      >
        <p className="bbutton uppercase text-[#00263E] text-center font-medium">Select a size</p>
        <div
          className="grid gap-x-3 gap-y-3 mt-4"
          style={{ gridTemplateColumns: `repeat(${Math.min(product?.variants?.length ?? 6, 6)}, minmax(0, 1fr))` }}
        >
          {product?.variants?.map((variant) => (
             <React.Fragment key={variant.id}>
              {variant.available && !unavailableForShipping?.includes(`${variant.id}`) ? (
                <button
                  key={variant.id}
                  type="button"
                  className={clsx("blabel p-0 h-auto min-h-[auto] hover:underline", {
                    "text-[#00263E]": variant.available,
                    "text-[#BBBBBD] cursor-default": !variant.available,
                    "opacity-60": addingVariantId === Number(variant.id),
                  })}
                  onClick={(event) => handleQuickAdd(event, variant)}
                  disabled={!variant.available || addingVariantId === Number(variant.id)}
                >
                  {variant.options[1]}
                </button>
              ) : (
                <button
                  key={variant.id}
                  className="blabel p-0 h-auto min-h-[auto] text-[#BBBBBD] cursor-default opacity-60"
                >
                  {variant.options[1]}
                </button>
              )}
             </React.Fragment>
          ))}
        </div>
      </div>
    </>
  );
}

export default ProductTileQuickAddOnHover;